interface Translations {
  [key: string]: {
    [key: string]: string;
  };
}

// Translation dictionary
export const translations: Translations = {
  // Page titles and common elements
  'Create New Request': {
    ru: 'Создать новую заявку'
  },
  'Edit Request': {
    ru: 'Редактировать заявку'
  },
  'Review Your Request': {
    ru: 'Проверьте вашу заявку'
  },
  'Add Details': {
    ru: 'Добавить детали'
  },
  
  // Steps
  'Step': {
    ru: 'Шаг'
  },
  'of': {
    ru: 'из'
  },
  'Review & Submit': {
    ru: 'Проверка и отправка'
  },
  
  // Form fields
  'Shipping Date': {
    ru: 'Дата отгрузки'
  },
  'Comment': {
    ru: 'Комментарий'
  },
  'Add any additional notes or comments here...': {
    ru: 'Добавьте любые дополнительные заметки или комментарии здесь...'
  },
  'No shipping date set': {
    ru: 'Дата отгрузки не установлена'
  },
  'No comment added': {
    ru: 'Комментарий не добавлен'
  },
  'Point of Sale': {
    ru: 'Точка продажи'
  },
  
  // Table headers
  'Product': {
    ru: 'Товар'
  },
  'Quantity': {
    ru: 'Количество'
  },
  'Price': {
    ru: 'Цена'
  },
  
  // Buttons
  'Cancel': {
    ru: 'Отмена'
  },
  'Back': {
    ru: 'Назад'
  },
  'Next': {
    ru: 'Далее'
  },
  'Create Request': {
    ru: 'Отправить заявку'
  },
  'Update Request': {
    ru: 'Обновить заявку'
  },
  
  // Product card
  'Previously requested': {
    ru: 'Ранее запрошено'
  },
  
  // Login page
  'Enter Phone Number': {
    ru: 'Введите номер телефона'
  },
  'Enter Password': {
    ru: 'Введите пароль'
  },
  'Create Account': {
    ru: 'Создать аккаунт'
  },
  'Phone Number': {
    ru: 'Номер телефона'
  },
  'Password': {
    ru: 'Пароль'
  },
  'Password must be at least 8 characters': {
    ru: 'Пароль должен содержать не менее 8 символов'
  },
  'First Name': {
    ru: 'Имя'
  },
  'Last Name': {
    ru: 'Фамилия'
  },
  'Login': {
    ru: 'Войти'
  },
  'Register': {
    ru: 'Зарегистрироваться'
  },
  'Continue': {
    ru: 'Продолжить'
  },
  'Back to Phone Number': {
    ru: 'Назад к номеру телефона'
  },
  'Select Point of Sale': {
    ru: 'Выберите точку продажи'
  },
  'An error occurred': {
    ru: 'Произошла ошибка'
  },
  'Invalid credentials': {
    ru: 'Неверные учетные данные'
  },
  'Registration failed': {
    ru: 'Регистрация не удалась'
  },
  'User not found': {
    ru: 'Пользователь не найден'
  },
  
  
  // Requests list
  'ID': {
    ru: 'ID'
  },
  'Status': {
    ru: 'Статус'
  },
  'Created At': {
    ru: 'Создано'
  },
  'Actions': {
    ru: 'Действия'
  },
  'No requests found': {
    ru: 'Запросы не найдены'
  },
  'Items': {
    ru: 'Товары'
  },
  'Loading...': {
    ru: 'Загрузка...'
  },
  'Hello': {
    ru: 'Салем'
  },
  'shop': {
    ru: 'магазин'
  },
  'franchise': {
    ru: 'франшиза'
  },
  'workshop': {
    ru: 'цех'
  },
  'Type of Delivery': {
    ru: 'Тип доставки'
  },
  'Delivery': {
    ru: 'Доставка'
  },
  'Pickup': {
    ru: 'Самовывоз'
  },
  'delivery': {
    ru: 'Доставка'
  },
  'pickup': {
    ru: 'Самовывоз'
  },
  'Edit': {
    ru: 'Редактировать'
  },
  'Accept': {
    ru: 'Принять'
  },
  
  
  // Accept request
  'Accept Request': {
    ru: 'Принять заявку'
  },
  'Created at': {
    ru: 'Создано'
  },
  'Accept this item': {
    ru: 'Принять этот товар'
  },
  'Reason for rejection': {
    ru: 'Причина отказа'
  },
  'Requests': {
    ru: 'Заявки'
  },
  'Request not found': {
    ru: 'Запрос не найден'
  },
  'Account Not Connected': {
    ru: 'Аккаунт не подключен'
  },
  'Your account is not connected to any point of sale. Please contact the administrator.': {
    ru: 'Ваш аккаунт не привязан ни к одной точке продажи. Пожалуйста, свяжитесь с администратором.'
  },
  'Logout': {
    ru: 'Выйти'
  },
  'Workshop': {
    ru: 'Цех'
  },
  'Shipping Address': {
    ru: 'Адрес доставки'
  },
  'Enter delivery address...': {
    ru: 'Введите адрес доставки...'
  },
  // Support page
  'Support': {
    ru: 'Bambino AI'
  },
  'Contact Support': {
    ru: 'Связаться с поддержкой'
  },
  'How can we help you?': {
    ru: 'Чем мы можем помочь?'
  },
  'Your Name': {
    ru: 'Ваше имя'
  },
  'Your Email': {
    ru: 'Ваш email'
  },
  'Subject': {
    ru: 'Тема'
  },
  'Message': {
    ru: 'Сообщение'
  },
  'Send Message': {
    ru: 'Отправить сообщение'
  },
  'Please tell us what you need help with': {
    ru: 'Пожалуйста, расскажите с чем вам нужна помощь'
  },
  'Message sent successfully': {
    ru: 'Сообщение успешно отправлено'
  },
  'Error sending message': {
    ru: 'Ошибка при отправке сообщения'
  },
  'Please fill in all required fields': {
    ru: 'Пожалуйста, заполните все обязательные поля'
  },
  'Support Center': {
    ru: 'Центр поддержки'
  },
  'Email': {
    ru: 'Email'
  },
  'Response Time': {
    ru: 'Время ответа'
  },
  'We typically respond to support requests within 24-48 hours during business days.': {
    ru: 'Обычно мы отвечаем на запросы в течение 24-48 часов в рабочие дни.'
  },
  'Type your message...': {
    ru: 'Введите ваше сообщение...'
  },
  'Send': {
    ru: 'Отправить'
  },
  'Online': {
    ru: 'В сети'
  },
  'Offline': {
    ru: 'Не в сети'
  },
  'No messages yet': {
    ru: 'Пока нет сообщений'
  },
  'Start a conversation with our support team': {
    ru: 'Начните разговор с нашей командой поддержки'
  },
  
  // Privacy Policy
  'Privacy Policy': {
    ru: 'Политика конфиденциальности'
  },
  'Last updated': {
    ru: 'Последнее обновление'
  },
  'June': {
    ru: 'июня'
  },
  'Introduction': {
    ru: 'Введение'
  },
  'This Privacy Policy describes how we collect, use, process, and disclose your information, including personal information, in conjunction with your access to and use of the Bambino Workshop iOS application.': {
    ru: 'Эта Политика конфиденциальности описывает, как мы собираем, используем, обрабатываем и раскрываем вашу информацию, включая личную информацию, в связи с вашим доступом и использованием iOS-приложения Bambino Цех.'
  },
  'When this policy mentions "we," "us," or "our," it refers to Bambino Workshop that is responsible for your information under this Privacy Policy.': {
    ru: 'Когда в этой политике упоминается "мы", "нас" или "наш", это относится к Bambino Цех, которая несет ответственность за вашу информацию в соответствии с настоящей Политикой конфиденциальности.'
  },
  'App Information': {
    ru: 'Информация о приложении'
  },
  'App Name': {
    ru: 'Название приложения'
  },
  'Platform': {
    ru: 'Платформа'
  },
  'App Store Link': {
    ru: 'Ссылка в App Store'
  },
  'Information We Collect': {
    ru: 'Информация, которую мы собираем'
  },
  'We collect various types of information through our iOS app to provide and improve our services to you:': {
    ru: 'Мы собираем различные типы информации через наше iOS-приложение для предоставления и улучшения наших услуг для вас:'
  },
  'Account Information': {
    ru: 'Информация об учетной записи'
  },
  'We collect information such as your name, phone number, email address, and other details you provide when registering with the Bambino Цех app.': {
    ru: 'Мы собираем такую информацию, как ваше имя, номер телефона, адрес электронной почты и другие данные, которые вы предоставляете при регистрации в приложении Bambino Цех.'
  },
  'Device Information': {
    ru: 'Информация об устройстве'
  },
  'We may collect information about your iOS device, including device model, operating system version, unique device identifiers, and mobile network information.': {
    ru: 'Мы можем собирать информацию о вашем устройстве iOS, включая модель устройства, версию операционной системы, уникальные идентификаторы устройства и информацию о мобильной сети.'
  },
  'Transaction Information': {
    ru: 'Информация о транзакциях'
  },
  'We collect information related to your requests, including products, quantities, and order history submitted through the app.': {
    ru: 'Мы собираем информацию, связанную с вашими запросами, включая продукты, количество и историю заказов, отправленных через приложение.'
  },
  'Usage Information': {
    ru: 'Информация об использовании'
  },
  'We collect information about how you interact with our app, including features you use, time spent on the app, and other activities.': {
    ru: 'Мы собираем информацию о том, как вы взаимодействуете с нашим приложением, включая используемые функции, время, проведенное в приложении, и другие действия.'
  },
  'How We Use Your Information': {
    ru: 'Как мы используем вашу информацию'
  },
  'We use the information we collect for various purposes, including:': {
    ru: 'Мы используем собранную информацию для различных целей, включая:'
  },
  'Providing Services': {
    ru: 'Предоставление услуг'
  },
  'To provide, maintain, and improve our app features and functionality for you.': {
    ru: 'Предоставлять, поддерживать и улучшать функции и функциональность нашего приложения для вас.'
  },
  'Communication': {
    ru: 'Коммуникация'
  },
  'To communicate with you about your requests, app updates, and other customer support matters.': {
    ru: 'Общаться с вами о ваших запросах, обновлениях приложения и других вопросах поддержки клиентов.'
  },
  'Security': {
    ru: 'Безопасность'
  },
  'To detect, prevent, and address security issues and unauthorized access to the app.': {
    ru: 'Обнаруживать, предотвращать и решать проблемы безопасности и несанкционированного доступа к приложению.'
  },
  'App Performance': {
    ru: 'Производительность приложения'
  },
  'To analyze app performance, fix bugs, and optimize the user experience.': {
    ru: 'Анализировать производительность приложения, исправлять ошибки и оптимизировать пользовательский опыт.'
  },
  'Data Retention': {
    ru: 'Хранение данных'
  },
  'We retain your personal information for as long as necessary to provide you with our app services and as required by applicable law. We may retain your information for a longer period if required for legal obligations or to resolve disputes.': {
    ru: 'Мы храним вашу личную информацию столько времени, сколько необходимо для предоставления вам услуг нашего приложения и в соответствии с требованиями применимого законодательства. Мы можем хранить вашу информацию в течение более длительного периода, если это требуется для выполнения юридических обязательств или разрешения споров.'
  },
  'Contact Us': {
    ru: 'Свяжитесь с нами'
  },
  'If you have any questions about this Privacy Policy or our data practices, please contact us at:': {
    ru: 'Если у вас есть какие-либо вопросы относительно настоящей Политики конфиденциальности или наших практик обработки данных, пожалуйста, свяжитесь с нами по адресу:'
  },
  'Shipping': {
    ru: 'Доставка'
  },
  'Create a new request to get started': {
    ru: 'Создать новый запрос, чтобы начать'
  },
  
  // Connection error dialog
  'Connection Error': {
    ru: 'Ошибка соединения'
  },
  'Could not connect to the server. Please check your internet connection and try again.': {
    ru: 'Не удалось подключиться к серверу. Пожалуйста, проверьте подключение к интернету и попробуйте снова.'
  },
  'Redirecting to login page in': {
    ru: 'Перенаправление на страницу входа через'
  },
  'Try Again': {
    ru: 'Попробовать снова'
  },
  'Document Type': {
    ru: 'Тип документа'
  },
  'Invoice': {
    ru: 'Счет фактура'
  },
  'Waybill': {
    ru: 'Мягкая накладная'
  },
  'No document type selected': {
    ru: 'Тип документа не выбран'
  },
  'For horeca, minimum order quantity for Узкие Кюветы is 3 items': {
    ru: 'Минимальное количество заказа для Узких Кювет составляет 3 штуки'
  },
};

// Current language
let currentLanguage = 'ru'; // Default to Russian

// Function to translate text
export const t = (text: string): string => {
  if (!text) return '';
  
  // Return the translation if it exists, otherwise return the original text
  return translations[text]?.[currentLanguage] || text;
};

// Function to set language
export const setLanguage = (lang: string): void => {
  currentLanguage = lang;
};

// Function to get current language
export const getLanguage = (): string => {
  return currentLanguage;
}; 